function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#D6D6D6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.258 31.933c8.604 0 15.578-7.134 15.578-15.933 0-8.8-6.974-15.933-15.578-15.933S.679 7.201.679 16c.01 8.795 6.98 15.922 15.579 15.933zm0-28.353c6.707 0 12.144 5.56 12.144 12.42s-5.437 12.42-12.144 12.42S4.114 22.86 4.114 16c.008-6.856 5.44-12.412 12.144-12.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.863 12.663l-2.429-2.484-6.707 6.86-2.566-2.625-2.43 2.484 4.996 5.109z"
}));

const SvgIcVIdle = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcVIdle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-v-idle.923a9467.svg";
export { ForwardRef as ReactComponent };